export default {
  name: 'jak',
  defaults: [
    {
      svg: {
        widthsAndHeights: 'path/to/svg oder SVG',
        length: 'path/to/svg oder SVG',
        notches: 'path/to/svg oder SVG'
      }
    },
    {
      profilColor: ''
    },
    {
      a: {
        min: 400,
        max: 99000,
        default: 400
      }
    },
    {
      a1: {
        min: 50,
        max: 300,
        steps: 10,
        default: 250
      }
    },
    {
      a2: {
        min: 50,
        max: 300,
        steps: 10,
        default: 250
      }
    },
    {
      totalLength: 500
    },
    {
      totalLengthOfOneElement: 3750
    },
    {
      b: {
        min: 160,
        max: 300,
        steps: 10,
        default: 180
      }
    },
    {
      h: {
        min: 35,
        max: 35,
        default: 35
      }
    },
    {
      w: {
        min: 20,
        max: 260,
        steps: 5,
        default: 20
      }
    },
    {
      e: {
        min: 105,
        max: 160,
        steps: 5,
        default: 125
      }
    },
    {
      d1: {
        min: 100,
        max: 480,
        steps: 5,
        default: 280
      }
    },
    {
      d2: {
        min: 80,
        max: 300,
        steps: 5,
        default: 200
      }
    },
    {
      c: {
        min: 160,
        max: 700,
        steps: 5,
        default: 500
      }
    },
    {
      f: {
        min: 0,
        max: 150,
        default: 0
      }
    },
    {
      g: {
        min: 0,
        max: 200,
        default: 0
      }
    },
    {
      dripEdgeProfile: 0
    },
    {
      wallProfiles: ''
    },
    {
      vacuumPanels: ''
    },
    {
      vipWidth: 20
    }
  ],

  /*
  * getters
  */

  get: function (value) {
    for (var i = 0; i < this.defaults.length; i++) {
      var obj = this.defaults[i]
      for (var key in obj) {
        if (key === value) {
          return obj[key]
        }
      }
    }
  },

  /*
  * set depedencies for values
  */

  // if Vakuumpanel is added Change values
  hasVIP: function () {
    const changedValues = {
      w: {
        min: 30,
        max: 260,
        default: 40,
        vipWidth: 20
      },
      b: {
        min: 180,
        max: 400,
        default: 200
      },
      c: {
        min: 360,
        max: 700,
        default: 500
      },
      d1: {
        min: 100,
        max: 300,
        default: 300
      }
    }
    return changedValues
  },

  validateData: function (currentOrder) {
  },
  getErrors: function (currentOrder) {
    let errors = {}
    for (var i = 0; i < this.defaults.length; i++) {
      var obj = this.defaults[i]
      for (var key in obj) {
        var keyData = obj[key]
        var valueOfOrder = currentOrder[key]
        if (this.checkMin(key, keyData, valueOfOrder, currentOrder)) {
          errors[key] = ('min')
        }
        if (this.checkMax(key, keyData, valueOfOrder, currentOrder)) {
          errors[key] = ('max')
        }

        if (this.checkSteps(key, keyData, valueOfOrder)) {
          errors[key] = ('steps')
        }

        if (key === 'c' || key === 'd1') {
          if (currentOrder.c < currentOrder.d1) {
            errors[key] = ('d1BiggerThenC')
          }
        }

        if (key === 'b') {
          if (currentOrder.e + currentOrder.h + currentOrder.w !== currentOrder.b) {
            errors[key] = ('bIsNotCorrect')
          }
        }

        if (key === 'g') {
          if (currentOrder.w < currentOrder.g) {
            errors[key] = ('gIsgraterThanW')
          }
        }
      }
    }
    return errors
  },
  getMins: function (currentOrder) {
    let minArray = []
    for (var i = 0; i < this.defaults.length; i++) {
      var obj = this.defaults[i]
      for (var key in obj) {
        if (key === 'w' && currentOrder.vacuumPanels === 'vip') {
          minArray[key] = this.hasVIP()['w'].min
        } else if (key === 'b' && currentOrder.vacuumPanels === 'vip') {
          minArray[key] = this.hasVIP()['b'].min
        } else if (key === 'c' && currentOrder.vacuumPanels === 'vip') {
          minArray[key] = this.hasVIP()['c'].min
        } else if (key === 'd1' && currentOrder.vacuumPanels === 'vip') {
          minArray[key] = this.hasVIP()['d1'].min
        } else {
          minArray[key] = obj[key].min
        }
      }
    }
    return minArray
  },
  checkMin: function (key, keyData, valueOfOrder, currentOrder) {
    let minError = false
    if (keyData.min) {
      if (key === 'w' && this.hasVIP()['w'].min > valueOfOrder && currentOrder.vacuumPanels === 'vip') {
        minError = true
      } else if (key === 'b' && this.hasVIP()['b'].min > valueOfOrder && currentOrder.vacuumPanels === 'vip') {
        minError = true
      } else if (key === 'c' && this.hasVIP()['c'].min > valueOfOrder && currentOrder.vacuumPanels === 'vip') {
        minError = true
      } else if (key === 'd1' && this.hasVIP()['d1'].min > valueOfOrder && currentOrder.vacuumPanels === 'vip') {
        minError = true
      } else if (keyData.min > valueOfOrder) {
        minError = true
      }
    }
    return minError
  },

  checkMax: function (key, keyData, valueOfOrder) {
    let maxError = false
    if (keyData.max) {
      if (keyData.max < valueOfOrder) {
        maxError = true
      }
    }
    return maxError
  },

  checkSteps: function (key, keyData, valueOfOrder) {
    let stepsError = false
    if (keyData.steps) {
      if (valueOfOrder % keyData.steps) {
        stepsError = true
      }
    }
    return stepsError
  },

  getWarnings: function (currentOrder) {
    let currentWarnings = {}

    // elementLengths related warnings
    let elementLengths = {}
    elementLengths['totalLengthOfOneElement'] = (currentOrder.totalElements > 1)
    elementLengths['totalElements'] = (currentOrder.totalElements > 1)
    currentWarnings['elementLengths'] = elementLengths

    // elementHeights related warnings
    let elementHeights = {}
    elementHeights['higherThanStandard'] = (currentOrder.c > 500)
    elementHeights['specialConfigD2'] = (currentOrder.d2 < 90) ? 90 : false
    currentWarnings['elementHeights'] = elementHeights

    // elementWidths related warnings
    let elementWidths = {}
    // elementWidths['eIs100'] = (currentOrder.e === 100)
    elementWidths['eIsLowerThanEquals115'] = (currentOrder.e <= 115)
    elementWidths['elementWidthcalculationWarning'] = (currentOrder.e + currentOrder.h + currentOrder.w !== currentOrder.b)
    currentWarnings['elementWidths'] = elementWidths

    // vacuumPanels related warnings
    let vacuumPanels = {}
    vacuumPanels['wIsToSmall'] = (currentOrder.w < 40)
    vacuumPanels['cIsToSmall'] = (currentOrder.c < 360)
    currentWarnings['vacuumPanels'] = vacuumPanels

    // endProfiles related warnings
    let endProfiles = {}
    endProfiles['onlyT'] = (currentOrder.w < 60)
    endProfiles['wallProfilesForBoxes'] = (!currentOrder.isBox)
    currentWarnings['endProfiles'] = endProfiles

    return currentWarnings
  },

  // Helper functions

  log: function () {
    // console.log(this)
  }
}
